// ISO 639-2/3 language codes (as used across the app) → BCP-47 tags for the
// browser Speech APIs (recognition + synthesis).
const MAP = {
  eng: 'en-US', rus: 'ru-RU', ita: 'it-IT', por: 'pt-PT', tur: 'tr-TR', spa: 'es-ES', swe: 'sv-SE', nld: 'nl-NL',
  cmn: 'zh-CN', vie: 'vi-VN', kor: 'ko-KR', ara: 'ar-SA', jpn: 'ja-JP', ell: 'el-GR', deu: 'de-DE', fra: 'fr-FR',
}
export const speechLocaleOf = (code) => MAP[String(code || '').toLowerCase()] || 'en-US'
export default speechLocaleOf
